/**
 *  important: make sure no spaces around the comma, the string will be processed with split method to get every single type's name
 *  We are using MIME types instead of common extension, for details, see {@link https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types}
 */
export enum UploadFileType {
    All = "all",
    AllImages = "image/png,image/jfif,image/pjpeg,image/jpeg,image/pjp,image/jpg,image/bmp,image/dib,image/gif,image/webp,image/svg+xml",
    AllVideos = "video/mp4,video/x-msvideo,video/x-matroska,video/webm,video/quicktime",
    ProfileImages = "image/png,image/jpeg,image/jpg,image/bmp",
    MediaGalleryImages = "image/png,image/jpeg,image/jpg,image/bmp,image/gif,image/webp,image/svg+xml",
    PDF = "application/pdf",
    SpreadSheets = ".csv,application/vnd.ms-excel,.xlt,application/vnd.ms-excel,.xla,application/vnd.ms-excel,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xltx,application/vnd.openxmlformats-officedocument.spreadsheetml.template,.xlsm,application/vnd.ms-excel.sheet.macroEnabled.12,.xltm,application/vnd.ms-excel.template.macroEnabled.12,.xlam,application/vnd.ms-excel.addin.macroEnabled.12,.xlsb,application/vnd.ms-excel.sheet.binary.macroEnabled.12"
}

// keys of this object will be used as rendered template text
export const FILE_SIZE: {[key: string]: number} = {
    "25 MB": 26214400,
    "50 MB": 52428800,
    "2 GB": 2147483648,
}

export const FileSize = {
    Maximum: {
        Images: {
            Size25MB: FILE_SIZE["25 MB"],
            Size50MB: FILE_SIZE["50 MB"],
        },
        Attachment: {
            Size25MB: FILE_SIZE["25 MB"],
            Size50MB: FILE_SIZE["50 MB"],
            Size2GB: FILE_SIZE["2 GB"],
        },
        PDF: {
            Size25MB: FILE_SIZE["25 MB"],
        }
    }
};

export type FileSize = (typeof FILE_SIZE)[keyof typeof FILE_SIZE];
